const MIN_POSSIBLE_VALUES = 1;
export const MAX_LENGTH_POSSIBLE_VALUE = 255;

export const possibleValuesValidation = (possibleValues: string[], id?: number): string[] => {
    const errorMassages = [];

    if (possibleValues.length < MIN_POSSIBLE_VALUES) {
        errorMassages.push(
            `Some of the ${!id ? 'added' : 'update'} attribute have incorrect "Possible Values".
            "Possible Values" must have at least ${MIN_POSSIBLE_VALUES} example`,
        );
    }

    return errorMassages;
};
